import { NavLink, Outlet } from "react-router-dom";
import ApplicationLayoutBodyNavigation from "@rio-cloud/rio-uikit/ApplicationLayoutBodyNavigation";
import SubNavigation from "@rio-cloud/rio-uikit/SubNavigation";
import BackofficeLayout from "../BackofficeLayout";

const BudgetPage = () => {
  const submenu = (
    <ApplicationLayoutBodyNavigation>
      <SubNavigation
        navItems={[
          {
            key: "notification-users",
            route: (
              <NavLink to="/backoffice/budget/notification-users">
                Usuários a serem notificados
              </NavLink>
            ),
          },
        ]}
      />
    </ApplicationLayoutBodyNavigation>
  );

  return (
    <BackofficeLayout submenu={submenu}>
      <Outlet />
    </BackofficeLayout>
  );
};

export default BudgetPage;

